document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-filter]').forEach((filter) => {
    const buttons = Array.from(filter.querySelectorAll('[data-filter-type]'));
    const cards = Array.from(filter.querySelectorAll('[data-product-type]'));
    const count = filter.querySelector('[data-filter-count]');

    const applyFilter = (type) => {
      let visible = 0;
      cards.forEach((card) => {
        const matches = type === 'all' || card.dataset.productType === type || (type === 'vaults' && ['Vault', 'Premium Vault', 'Complete Vault'].includes(card.dataset.productType));
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      buttons.forEach((button) => {
        const selected = button.dataset.filterType === type;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (count) count.textContent = `${visible} resource${visible === 1 ? '' : 's'} shown`;
    };

    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filterType)));
    applyFilter('all');
  });

  document.querySelectorAll('[data-moment-card]').forEach((card) => {
    card.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && card.dataset.momentHref) {
        event.preventDefault();
        window.location.href = card.dataset.momentHref;
      }
    });
  });

  document.querySelectorAll('[data-library]').forEach((library) => {
    const viewButtons = Array.from(library.querySelectorAll('[data-library-target]'));
    const views = Array.from(library.querySelectorAll('[data-library-view]'));

    const selectView = (target) => {
      views.forEach((view) => { view.hidden = view.dataset.libraryView !== target; });
      viewButtons.forEach((button) => {
        const selected = button.dataset.libraryTarget === target;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    viewButtons.forEach((button) => button.addEventListener('click', () => selectView(button.dataset.libraryTarget)));

    library.querySelectorAll('[data-library-filter]').forEach((filter) => {
      const buttons = Array.from(filter.querySelectorAll('[data-library-filter-type]'));
      const cards = Array.from(filter.parentElement.querySelectorAll('[data-library-item]'));
      const applyFilter = (type) => {
        cards.forEach((card) => { card.hidden = type !== 'all' && card.dataset.libraryType !== type; });
        buttons.forEach((item) => {
          const selected = item.dataset.libraryFilterType === type;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      };
      buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.libraryFilterType)));
      applyFilter(buttons.find((button) => button.classList.contains('is-active'))?.dataset.libraryFilterType || 'all');
    });
  });

  document.querySelectorAll('[data-shop-directory]').forEach((directory) => {
    // Product cards also carry data-shop-type, so the button lists must exclude
    // anything marked as a product or these would be treated as filter controls.
    const typeButtons = Array.from(directory.querySelectorAll('[data-shop-type]:not([data-shop-product])'));
    const collectionButtons = Array.from(directory.querySelectorAll('[data-shop-collection]:not([data-shop-product])'));
    const cards = Array.from(directory.querySelectorAll('[data-shop-product]'));
    const count = directory.querySelector('[data-shop-count]');
    const search = directory.querySelector('[data-shop-search]');
    const sort = directory.querySelector('[data-shop-sort]');
    const grid = directory.querySelector('[data-shop-grid]');
    const empty = directory.querySelector('[data-shop-empty]');
    const resets = Array.from(directory.querySelectorAll('[data-shop-reset]'));
    const total = cards.length;
    let activeType = 'all';
    let activeCollection = 'all';
    let query = '';

    // Sorting reorders the already-rendered nodes rather than refetching, so cover
    // images never reload. 'featured' restores the server order captured in markup.
    const applySort = () => {
      if (!grid || !sort) return;
      const mode = sort.value;
      const ordered = cards.slice().sort((a, b) => {
        const priceA = parseFloat(a.dataset.shopPrice || '0');
        const priceB = parseFloat(b.dataset.shopPrice || '0');
        const titleA = a.dataset.shopTitle || '';
        const titleB = b.dataset.shopTitle || '';
        if (mode === 'price-asc') return priceA - priceB;
        if (mode === 'price-desc') return priceB - priceA;
        if (mode === 'title-asc') return titleA.localeCompare(titleB);
        if (mode === 'title-desc') return titleB.localeCompare(titleA);
        return parseInt(a.dataset.shopOrder || '0', 10) - parseInt(b.dataset.shopOrder || '0', 10);
      });
      ordered.forEach((card) => grid.appendChild(card));
    };

    const applyFilters = () => {
      let visible = 0;
      cards.forEach((card) => {
        const typeMatches = activeType === 'all' || card.dataset.shopType === activeType;
        const collections = (card.dataset.shopCollections || '').split(' ');
        const collectionMatches = activeCollection === 'all' || collections.includes(activeCollection);
        const searchMatches = query === '' || (card.dataset.shopTitle || '').includes(query);
        const matches = typeMatches && collectionMatches && searchMatches;
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      typeButtons.forEach((button) => {
        const selected = button.dataset.shopType === activeType;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      collectionButtons.forEach((button) => {
        const selected = button.dataset.shopCollection === activeCollection;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const filtered = activeType !== 'all' || activeCollection !== 'all' || query !== '';
      if (count) {
        count.textContent = filtered
          ? `Showing ${visible} of ${total} products`
          : `Showing all ${total} products`;
      }
      if (empty) empty.hidden = visible !== 0;
      resets.forEach((button) => { button.hidden = !filtered; });
    };

    const catalog = directory.querySelector('[data-shop-catalog]');

    typeButtons.forEach((button) => button.addEventListener('click', () => {
      activeType = button.dataset.shopType;
      applyFilters();
      // Pack tiles sit above the collapsed catalog: open it and bring the
      // filtered results into view so the choice has a visible result.
      if (catalog && button.classList.contains('shop-pack-tile')) {
        catalog.open = true;
        catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }));
    collectionButtons.forEach((button) => button.addEventListener('click', () => { activeCollection = button.dataset.shopCollection; applyFilters(); }));

    if (search) {
      search.addEventListener('input', () => {
        query = search.value.trim().toLowerCase();
        applyFilters();
      });
    }

    if (sort) {
      sort.addEventListener('change', () => {
        applySort();
        applyFilters();
      });
    }

    resets.forEach((button) => button.addEventListener('click', () => {
      activeType = 'all';
      activeCollection = 'all';
      query = '';
      if (search) search.value = '';
      applyFilters();
    }));

    applyFilters();
  });
});
